export default [
  {
    id: 1,
    title: "Volume Full set",
    hours: "3 hr ",
    price: "$190",
  },
  {
    id: 2,
    title: "Hybrid Full set",
    hours: "2 hr 30 min",
    price: "$95",
  },
  {
    id: 3,
    title: "2 Week Fill",
    hours: "1 hr 45 min",
    price: "$170",
  },
  {
    id: 4,
    title: "3 Week Fill",
    hours: "1 hr 50 min",
    price: "$170",
  },
  {
    id: 5,
    title: "Lash Removal",
    hours: "30 min",
    price: "$30",
  },
  {
    id: 6,
    title: "Lash Lift/Tint",
    hours: "1 hr",
    price: "$100",
  },
  {
    id: 7,
    title: "Brow Wax & Tint",
    hours: "35 min",
    price: "$40",
  },
  {
    id: 8,
    title: "Brow Lamination",
    hours: "1 hr",
    price: "$100",
  },
  {
    id: 9,
    title: "Ombre / Powder Brows",
    hours: "3 hr 30 min",
    price: "$400",
  },
];
